// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantManagementDataFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';
import {isNil} from 'lodash/fp';
const ROOT_URL = 'tenant/';

export default {

  /**
   * Get list of tenant groups
   * @returns {*}
   */
  getAllTenantGroups() {
    return fetch(`${ROOT_URL}allTenantGroups/`).get();
  },

  /**
   * Get list tenant (full)
   * @returns {*}
   */
  getAllTenantList() {
    return fetch(`${ROOT_URL}allTenants/`).get();
  },

  /**
   * Get list tenant (basic)
   * @returns {*}
   */
  getAllBasicTenantList() {
    return fetch(`${ROOT_URL}basicInfos/`).get();
  },

  /**
   * Get list of tenant groups and tenant within those groups
   * @returns {Promise}
   */
  getTenantGroupsHierarchy() {
    return fetch(`${ROOT_URL}tenantGroupsHierarchy/`).get();
  },

  /**
   * Get list tenant (name)
   * @returns {*}
   */
  getAllNameTenantList() {
    return fetch(`${ROOT_URL}namesOnly/`).get();
  },

  /**
   * get all modules base on license
   * @returns {*[]}
   */
  getAllModulesOfLicense() {
    return fetch('License/currenttoken/')
      .get()
      .then(result => result && result.modules);
  },

  /**
   * Save a tenant
   * @param tenant
   * @returns {promise}
   */
  saveTenant(tenant) {
    return fetch(ROOT_URL, { prefer: 'minimal' }).post(tenant);
  },

  /**
   * Delete a tenant
   * @param id
   * @returns {promise}
   */
  deleteTenant(id) {
    return fetch(ROOT_URL + id).delete();
  },

  /**
   * Active a tenant
   * @param id
   * @returns {*}
   */
  activeTenant(id) {
    return fetch(`${ROOT_URL}active/${id}`).post();
  },

  /**
   * Deactive a tenant
   * @param id
   * @returns {*}
   */
  deactiveTenant(id) {
    return fetch(`${ROOT_URL}deactive/${id}`).post();
  },

  /**
   * Get detail tenant
   * @returns {Object}
   */
  loadTenant(id) {
    return fetch( isNil(id) ? ROOT_URL : ROOT_URL + id, { prefer: 'minimal' }).get();
  },

  /**
   * load category accessibility available
   * @param  {number} type [0 - Report/template; 1 - Dashboard]
   * @return {Promise}
   */
  getCategoryAccessibility(type) {
    return fetch(`${ROOT_URL}availableCategory/${type}`).get();
  },

  /**
   * Load partial access limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialAccessLimits(data) {
    return fetch(`${ROOT_URL}accessLimits`).post(data);
  },

  /**
   * Load partial schedule limits
   * @param  {Object} data
   * @return {Promise}
   */
  loadPartialScheduleLimits(data) {
    return fetch(`${ROOT_URL}scheduleLimits`).post(data);
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.TenantManagementDataFetcher.js